/*
 * @Descripttion: 商家中心接口
 */
import * as config from "./config";
// 入驻店铺提交 - (展示页逻辑大改 - 不再需要了)
// export const NewshopSave = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/shop/save';
// 查询店铺信息
export const shopGetView = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/shop/get';
// 编辑修改店铺信息-直接修改
export const EDITshopSave = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/shop/update';
// 更改店铺信息-审核
// export const UPDATEshopSave = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/shop/update';
// 获取查询商家以及店铺统计信息
export const getgeneralInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/shop/get/general/info';
// 店铺内商品分页列表
export const getShopGoodsPage = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/v2/api/shop/goods/page';
// 店铺内商品状态数据
export const getcountStaus = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/shop/goods/page/count';
// 店铺内商品上架
export const goodsshelvesPut = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/shelf/';
// 店铺内商品下架
export const goodsshelfLower = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/take/down/';
// 店铺内商品批量上架
export const productsListing = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/shelf';
// 店铺内商品批量下架
export const productsRemoval = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/take/down';
// 获取用户商家入驻合同
export const supplierOne = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/supplier/one';
// 获取商家变更列表
export const supplierrecordList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/supplier/record/page';
// 获取商家变更信息实体
export const supplierrecordDesc = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/supplier/record/';
// 获取店铺变更列表
export const shoprecordList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/shop/record/page';
// 获取订单数据
export const shopOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/order/shopOrder';
// 解决方案
// 解决方案分类列表
export const solutionCategory = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/solution/category/list';
// 添加解决方案
export const solutionAdd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/solution/save';
// 获取单个解决方案
export const solutionGetOne = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/solution/get/';
// 修改解决方案
export const solutionUpdate = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/solution/update';
// 获取解决方案列表
export const getSolutionList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/solution/page';
// 更改解决方案上下架状态
export const solutionShelf = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/solution/shelf';
// 删除解决方案
export const solutionDelete = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/solution/delete/';

// 获取店铺交易统计
export const getStoreTransactionStatistics = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/shop/trade/count';
//获取店铺用户交易分析统计
export const getStoreUserTransactionAnalysisAndStatistics = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/shop/user/count/';

export const getSolutionList_ = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/solution/page';
